import { isObject } from './utils'

export function validateFilter(filter) {
  if (!isObject(filter)) return null

  let filterKeys = Object.keys(filter)
    .map(k => k.trim())
    .filter(k => k.length > 0)
  if (filterKeys.length < 1) return null

  let hasAtleastOne = false
  let validated = filterKeys.reduce((acc, k) => {
    let label = k
    let value = filter[k]
    if (typeof value === 'string') {
      let trimmed = value.trim()
      if (trimmed.length > 0) {
        acc[label] = value
        hasAtleastOne = true
      }
    }
    return acc
  }, {})

  return hasAtleastOne ? validated : null
}

export function iterateOverObjectTree(obj, fn) {
  if (isObject(obj)) {
    const allKeys = []
    for (const key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        const v = obj[key]
        allKeys.push(key)
        iterateOverObjectTree(v, fn)
      }
    }
    fn(obj, allKeys)

    // let allKeys = Object.keys(obj)
    // allKeys.forEach(k => {
    //   let v = obj[k]
    //   iterateOverObjectTree(v, fn)
    // })
    // fn(obj, allKeys)
  }

  if (Array.isArray(obj)) {
    for (let i = 0, len = obj.length; i < len; i++) {
      iterateOverObjectTree(obj[i], fn)
    }
  }

  return obj
}

/**
 *
 * @param {{ data: any[]; keys: string[]; path: string[] }} input
 * @returns
 */
export function createFiltersTree({ data, keys = [], path = [] }) {
  let res = {}

  keys.forEach((k, keyIndex) => {
    let isLastKeyIndex = keyIndex === keys.length - 1

    data.forEach(item => {
      if (!item) return

      // Navigate the path (works for both nested arrays or objects)
      // TODO: this should be a `getItem` param. Ask the user to provide an item  - defaults to `item`
      let obj = path.reduce((x, p) => (x ? x[p] : undefined), item)
      if (!obj) return

      // Get value (k can be a string key or a numeric index)
      const isArray = Array.isArray(obj)
      let value = isArray ? obj[keyIndex] : obj[k]
      // Basic validation and normalization
      if (value === undefined || value === null) return
      if (typeof value === 'number') value = value.toString()
      if (typeof value !== 'string') return

      // Build the nested structure in 'res'
      let resInnerObj = keys.slice(0, keyIndex).reduce((acc, prevKey, i) => {
        const valAtPrevKey = isArray ? obj[i] : obj[prevKey]
        return acc[valAtPrevKey]
      }, res)

      if (resInnerObj) {
        resInnerObj[value] = isLastKeyIndex ? true : resInnerObj[value] || {}
      }
    })
  })

  // Final processing (sorting keys)
  return Object.keys(res).length > 0
    ? iterateOverObjectTree(res, (obj, keysList) => {
        Object.defineProperty(obj, '_keys_', {
          enumerable: false,
          configurable: true,
          value: keysList.sort((a, b) => a.localeCompare(b)),
        })
      })
    : res
}

export function isFilterSelectable(selectedValues, index) {
  if (index < 0 || index >= selectedValues.length) return false

  let slice = selectedValues.slice(0, index)
  const isTuple = Array.isArray(selectedValues[0])
  return isTuple ? slice.every(([key, value]) => !!value) : slice.every(v => !!v)
}

export function getCurrentFilterObject({ selectedValues, index, transformedFiltersObject }) {
  let selectable = isFilterSelectable(selectedValues, index)

  if (!selectable) return null
  if (selectable) {
    const isTuple = Array.isArray(selectedValues[0])
    let res = selectedValues.slice(0, index).reduce((x, maybeTuple) => {
      let value = isTuple ? maybeTuple[1] : maybeTuple
      return x[value]
    }, transformedFiltersObject)

    return res
  }
}

/**
 *
 * @param {string[]} keys - ["Make", "Model", "Wheel"]
 * @param {Record<string, string>} initialValues - { Make: 'BMW', Year: '2018', HP: '800' }
 * @returns
 */
export function initializeFilter(keys, tree, initialValues) {
  let currentNode = tree
  return new Map(
    Array.from({ length: keys.length }, (_, i) => {
      const key = keys[i]
      let value = initialValues[key] || initialValues[key.toLocaleLowerCase()] || ''

      // is the value selectable/exist in the tree at this step?
      if (value && currentNode && currentNode[value]) {
        currentNode = currentNode[value]
        return [key, value]
      }

      currentNode = null
      return [key, '']
    }),
  )
}
